
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export default function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id') || '';

  useEffect(() => {
    // Build a unique key for this purchase so we only fire the pixel once
    const key = `fb_purchase_${sessionId || 'static500'}`;

    // If we've already tracked this purchase, skip
    if (localStorage.getItem(key)) return;

    // Guard against missing fbq function – this prevents runtime errors in dev or if the
    // pixel script hasn't loaded yet.
    if (typeof window.fbq === 'function') {
      try {
        window.fbq('track', 'Purchase', { value: 500.0, currency: 'USD' });
        localStorage.setItem(key, '1');
      } catch (err) {
        // Log the error but don't break the UI
        console.error('Failed to send Facebook Purchase event:', err);
      }
    } else {
      // Optional: you could queue the event and retry later if needed
      console.warn('Facebook pixel (fbq) is not available.');
    }
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-8">
          {/* Self‑closing <i> tag is valid JSX */}
          <i className="ri-check-line text-4xl text-emerald-600" />
        </div>
        <h1 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
          Payment Successful
        </h1>
        <p className="text-gray-600 text-base sm:text-lg leading-relaxed mb-10 font-['Inter']">
          Thanks! Your payment has been received. You'll get a confirmation email shortly.
        </p>
        <a
          href="https://bucketlistgolf.org/"
          className="inline-block bg-emerald-600 text-white px-8 py-3 rounded-md text-sm font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer font-['Inter']"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
}
